import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import axios from "axios";
import swal from "sweetalert";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import Widget from "../../components/Widget/Widget";
import { API_TIMEOUT, NIRLABA_PENERIMA, NIRLABA_PROGRAM } from "../../utils/index";
import {
  filterRowsByMitraLembaga,
  getMitraQueryParams,
} from "../../utils/adminMitra";
import { numberWithCommas } from "../../utils/func";

const { SearchBar } = Search;
const currentYear = new Date().getFullYear();
const listTahun = Array.from({ length: currentYear - 2018 + 1 }, (_, i) =>
  String(2018 + i)
).reverse();

const PenerimaNirlabaList = () => {
  const dispatch = useDispatch();
  const [tahun, setTahun] = useState(String(currentYear));
  const [program, setProgram] = useState([]);
  const [bantuan, setBantuan] = useState("");
  const [rows, setRows] = useState([]);
  const [idHapus, setIdHapus] = useState();
  const [modalDelete, setModalDelete] = useState(false);

  const loadProgram = (th) => {
    axios
      .get(NIRLABA_PROGRAM, {
        params: { tahun: th, ...getMitraQueryParams() },
        timeout: API_TIMEOUT,
      })
      .then((res) => {
        const data = filterRowsByMitraLembaga(res.data?.data || []);
        setProgram(data);
        if (data.length) setBantuan(data[0].bantuan);
        else {
          setBantuan("");
          setRows([]);
        }
      })
      .catch((err) => alert(err));
  };

  const loadPenerima = (th, ban) => {
    if (!th || !ban) {
      setRows([]);
      return;
    }
    axios
      .get(NIRLABA_PENERIMA, {
        params: { tahun: th, bantuan: ban, ...getMitraQueryParams() },
        timeout: API_TIMEOUT,
      })
      .then((res) => {
        const data = res.data?.data || [];
        setRows(data.map((item, i) => ({ ...item, nomor: i + 1 })));
      })
      .catch((err) => alert(err));
  };

  useEffect(() => {
    loadProgram(tahun);
  }, [tahun]);

  useEffect(() => {
    if (bantuan) loadPenerima(tahun, bantuan);
  }, [bantuan, tahun]);

  const hapus = () => {
    axios
      .delete(NIRLABA_PENERIMA + "/" + idHapus, { timeout: API_TIMEOUT })
      .then((res) => {
        if (res.data?.success === 1) {
          swal("Sukses", "Penerima dihapus", "success");
          setModalDelete(false);
          loadPenerima(tahun, bantuan);
        }
      })
      .catch((err) => alert(err));
  };

  const columns = [
    { dataField: "nomor", text: "No.", sort: true },
    { dataField: "nama", text: "Nama", sort: true },
    { dataField: "nik", text: "NIK" },
    { dataField: "nama_lembaga", text: "Lembaga" },
    { dataField: "desa", text: "Desa" },
    {
      dataField: "nilaiUang",
      text: "Nilai",
      formatter: (cell) => "Rp " + numberWithCommas(cell || 0),
    },
    {
      dataField: "id",
      text: "Aksi",
      formatter: (cell) => (
        <div>
          <Button
            color="success"
            size="xs"
            className="mr-2"
            onClick={() =>
              dispatch(push(`/admin/nirlaba/penerima/${cell}/edit`))
            }
          >
            Edit
          </Button>
          <Button
            color="danger"
            size="xs"
            onClick={() => {
              setIdHapus(cell);
              setModalDelete(true);
            }}
          >
            Hapus
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="page-top-line">
        <h2 className="page-title">
          Penerima <span className="fw-semi-bold">bantuan mitra</span>
        </h2>
      </div>
      <Widget>
        <ToolkitProvider keyField="id" data={rows} columns={columns} search>
          {(props) => (
            <div>
              <div className="d-flex justify-content-between mb-3 flex-wrap">
                <div className="d-flex align-items-center mb-2">
                  <SearchBar {...props.searchProps} />
                  <Input
                    type="select"
                    className="ml-2"
                    style={{ width: 120 }}
                    value={tahun}
                    onChange={(e) => setTahun(e.target.value)}
                  >
                    {listTahun.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </Input>
                  <Input
                    type="select"
                    className="ml-2"
                    style={{ minWidth: 220 }}
                    value={bantuan}
                    onChange={(e) => setBantuan(e.target.value)}
                  >
                    {program.map((item) => (
                      <option key={item.id} value={item.bantuan}>
                        {item.nama_lembaga} — {item.bantuan}
                      </option>
                    ))}
                  </Input>
                </div>
                <Button
                  color="info"
                  className="mr-2"
                  disabled={!bantuan}
                  onClick={() => {
                    const row = program.find((p) => p.bantuan === bantuan);
                    const q = new URLSearchParams({
                      tahun,
                      bantuan,
                    });
                    if (row && row.id_lembaga) {
                      q.set("id_lembaga", String(row.id_lembaga));
                    }
                    dispatch(
                      push(`/admin/nirlaba/bantuan-detail?${q.toString()}`)
                    );
                  }}
                >
                  Detail program
                </Button>
                <Button
                  color="primary"
                  onClick={() => dispatch(push("/admin/nirlaba/penerima/new"))}
                >
                  Input penerima
                </Button>
              </div>
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory()}
                bootstrap4
              />
            </div>
          )}
        </ToolkitProvider>
      </Widget>
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(false)}>
        <ModalHeader>Hapus penerima</ModalHeader>
        <ModalBody>Yakin menghapus penerima ini?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalDelete(false)}>
            Batal
          </Button>
          <Button color="danger" onClick={hapus}>
            Hapus
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PenerimaNirlabaList;
